export const EMPLOYEE_COUNT_OPTIONS = [
  '1-50',
  '50-200',
  '200-1000',
  '1000-2500',
  '2500>',
] as const;

export const ROLE_OPTIONS = ['Business user', 'Developer'] as const;

export const USAGE_OPTIONS = ['Enterprise', 'Agency', 'Personal'] as const;

export const REFERRAL_OPTIONS = [
  'Linkedin',
  'Facebook',
  'X (Twitter)',
  'Youtube',
  'Colleague',
] as const;
